<template>
    <span
        ref="toggle"
        class="c-checkbox-toggle"
        role="checkbox"
        :class="{
            'c-checkbox-toggle--checked': isChecked,
            'c-checkbox-toggle--unchecked': isUnchecked,
            'c-checkbox-toggle--disabled': disabled}"
        :disabled="disabled"
        :tabindex="disabled ? -1 : 0"
        :aria-checked="isChecked"
        @click.prevent="toggle()"
        @keypress.space.prevent="toggle()"
        @keypress.enter.prevent="submitForm($event)">
        <span class="c-checkbox-toggle__checked-icon" />

        <span class="c-checkbox-toggle__unchecked-icon" />

        <input
            type="checkbox"
            v-bind="$attrs"
            :value="value ? 1 : 0"
            :checked="value"
            @input.stop="toggle()"
            @change.stop="toggle()">

        <span class="c-checkbox-toggle__toggle" />
    </span>
</template>

<script>
export default {
    name: 'ToggleInput',

    inheritAttrs: false,

    props: {
        value: {type: Boolean},
        disabled: {type: Boolean},
    },

    computed: {
        isChecked() {
            return this.value === true;

        },

        isUnchecked() {
            return this.value === false;
        },
    },

    methods: {
        toggle() {
            if (this.disabled) {
                return;
            }

            this.focus();

            this.$emit('input', !this.value);
        },

        focus() {
            if (this.$refs.toggle && this.$refs.toggle.focus) {
                this.$refs.toggle.focus();
            }
        },

        submitForm(event) {
            const submitEvent = new CustomEvent('submit', {'bubbles': true, 'cancelable': true});
            event.target.closest('form').dispatchEvent(submitEvent);
        },
    },
};
</script>

<style scoped>
input {
    display: none;
}

.c-checkbox-toggle {
    display: inline-block;
    box-sizing: border-box;

    vertical-align: middle;

    position: relative;

    min-height: 28px !important;
    min-width: 50px !important;
    height: 28px !important;
    width: 50px !important;
    max-height: 28px !important;
    max-width: 50px !important;

    margin: 4px 0;

    border: 2px solid #8E8F93;
    border-radius: 14px;

    background-color: #F7F7F7;

    cursor: pointer;

    -webkit-transition: ease-in-out all 50ms;
    -moz-transition: ease-in-out all 50ms;
    -ms-transition: ease-in-out all 50ms;
    -o-transition: ease-in-out all 50ms;
    transition: ease-in-out all 50ms;
}

.c-checkbox-toggle:not(.c-checkbox-toggle--disabled):focus {
    border-color: #80bdff;
    outline: 0;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.c-checkbox-toggle.c-checkbox-toggle--disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.c-checkbox-toggle .c-checkbox-toggle__checked-icon,
.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::before,
.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::after {

    position: absolute;

    display: block;
    width: 10px;

    border-left: transparent solid 2px;
    border-bottom: transparent solid 2px;
}

.c-checkbox-toggle .c-checkbox-toggle__checked-icon {
    top: 9px;
    left: 7px;

    height: 5px;

    transform: rotate(-45deg);
}

.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::before,
.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::after {
    content: '';

    top: 11px;
    right: 7px;
}

.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::before {
    transform: rotate(-45deg);
}

.c-checkbox-toggle .c-checkbox-toggle__unchecked-icon::after {
    transform: rotate(45deg);
}

.c-checkbox-toggle .c-checkbox-toggle__toggle {
    content: '';

    display: block;
    box-sizing: border-box;

    position: absolute;
    top: 2px;
    left: 13px;

    width: 20px;
    height: 20px;

    border-radius: 50%;

    background-color: white;
    box-shadow: 0 2px 3px #555;

    -webkit-transition: ease-in-out left 50ms;
    -moz-transition: ease-in-out left 50ms;
    -ms-transition: ease-in-out left 50ms;
    -o-transition: ease-in-out left 50ms;
    transition: ease-in-out left 50ms;
}

.c-checkbox-toggle.c-checkbox-toggle--checked {
    border-color: #4CDA64;
    background-color: #4CDA64;
}

.c-checkbox-toggle.c-checkbox-toggle--checked .c-checkbox-toggle__checked-icon {
    border-color: #2d803a;
}

.c-checkbox-toggle.c-checkbox-toggle--checked .c-checkbox-toggle__toggle {
    left: 25px;
}

.c-checkbox-toggle.c-checkbox-toggle--unchecked {
    border-color: #D97B6F;
    background-color: #D97B6F;
}

.c-checkbox-toggle.c-checkbox-toggle--unchecked .c-checkbox-toggle__unchecked-icon::before,
.c-checkbox-toggle.c-checkbox-toggle--unchecked .c-checkbox-toggle__unchecked-icon::after {
    border-color: #804842;
}

.c-checkbox-toggle.c-checkbox-toggle--unchecked .c-checkbox-toggle__toggle {
    left: 1px;
}
</style>
